import React, { Fragment } from 'react';
import { IPathNode } from './interfaces';
import { NodeValueDisplay, TitleRow } from './TooltipUI';
import { getNodeStats } from './utils';
import { assertCondition } from '../../../utils/types';

interface IProps {
  nodes: IPathNode[];
  color: string;
}

export default ({ nodes, color }: IProps) => {
  assertCondition(nodes.length > 0, 'Must have more than 1 node');
  const firstNode = nodes[0];
  const displayText = firstNode.name;

  return (
    <>
      <TitleRow $color={color}>
        {displayText}
        <div>
          {nodes.map((node) => {
            const { percent } = getNodeStats(node);
            return (
              <Fragment key={node.id}>
                {' '}
                <span>
                  {node.groupName}:{' '}
                  <NodeValueDisplay>{percent}</NodeValueDisplay>
                </span>
              </Fragment>
            );
          })}
        </div>
      </TitleRow>
    </>
  );
};
